/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import InviteIcon from 'icons/InviteIcon';

const messages = defineMessages({
  title: {id: 'navigation.invite'},
});

const InviteItem = () => (
  <RouteLinkItem
    iconBefore={InviteIcon}
    route="midas/staff/invite"
    title={messages.title}
  />
);

export default InviteItem;
